export default __webpack_public_path__ + "static/media/play-store.36eaf743.svg";